<template>
  <b-form class="position-relative mb-3">
    <loader v-if="loader" />

    <b-form-group
      id="fieldset-customer-email"
      label-for="custom-email-input"
      :required="true"
      :state="emailState"
      :invalid-feedback="invalidFeedback"
    >
      <span slot="label">
        {{ $t('form.customer_email') }}
      </span>
      <b-form-input
        id="custom-email-input"
        v-model="email"
        type="email"
        required
        trim
        :disabled="!editMode"
        :placeholder="$t('form.email')"
        :state="editMode ? emailState : null"
        @input="emailTouched = true"
      />
    </b-form-group>

    <div class="d-flex justify-content-between">
      <b-btn @click.prevent="toggleEditMode" variant="outline-primary">
        {{ editMode ? $t('button.cancel') : $t('button.edit') }}
      </b-btn>
      <b-btn
        v-if="editMode"
        :disabled="!emailState || email == savedEmail"
        @click.prevent="editData"
      >
        {{ $t('button.update') }}
      </b-btn>
    </div>
  </b-form>
</template>

<script>
export default {
  name: "EditBillingEmail",
  props: {
    emailObject: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: 'live'
    },
    resource: {
      type: String,
      require: true,
      default: '',
    }
  },
  data() {
    return {
      email: '',
      savedEmail: '', 
      emailTouched: false,
      loader: false,
      editMode: false,
    }
  },
  created() {
    if (this.emailObject) {
      this.email = this.emailObject[this.mode];
      this.savedEmail = this.emailObject[this.mode];
    }
  },
  computed: {
    emailState() {
      if (!this.emailTouched) {
        return null;
      }

      return this.emailTouched && !this.invalidFeedback;
    },
    invalidFeedback() {
      if (!this.email.length) {
        return 'Please fill email';
      } else if (!this.email.includes('@') || !this.email.includes('.')) {
        return 'Invalid email';
      }

      return '';
    },
  },
  methods: {
    toggleEditMode(){
      this.editMode = !this.editMode;
      if (!this.editMode) {
        this.email = this.savedEmail;
      }
    },
    editData() {
      this.loader = true;
      this.putData(`resources/${this.resource}/pricing/payment-data/stripe/email/${this.mode}`, {
        customer_email: this.email
      }).then(({ data }) => {
        if (data) {
          this.email = data.customer_email;
          this.savedEmail = data.customer_email;
          this.emailTouched = false;
          this.$emit('email-changed');
        }
      }).finally(() => {
        this.loader = false;
        this.toggleEditMode();
      })
    }
  }
}
</script>
